const requests = new Map();
export function loadCompanyTableIdentity({ id, name }) {
  const token = ["token", "authToken", "jwt", "accessToken"].map(key => localStorage.getItem(key)).find(Boolean);
  if (!token) return Promise.resolve(null);
  const query = new URLSearchParams(id ? { id: String(id) } : { name });
  const key = `${token}:${query}`;
  const cached = requests.get(key);
  if (cached && Date.now() - cached.time < 60000) return cached.promise;
  const base = (process.env.REACT_APP_API_BASE || "").replace(/\/api\/?$/, "").replace(/\/$/, "");
  const promise = fetch(`${base}/api/companies/table-identity?${query}`, {
    credentials: "include", headers: { Authorization: `Bearer ${token}` },
  }).then(async response => {
    if (!response.ok) throw new Error("Company lookup failed");
    return (await response.json()).company || null;
  }).catch(() => { requests.delete(key); return null; });
  requests.set(key, { time: Date.now(), promise });
  return promise;
}
